/**
 * The Trade Ops Bunkers card's two money tiles, "Funding Required" and
 * "Avg ROCE", shared by the home dashboard and the My Workspace modules card.
 *
 * The server leaves both figures out for anyone the Trade Recaps screen
 * refuses (ledger row 149), so a missing figure means "not yours": it gets no
 * tile, never $0. Avg ROCE arrives empty when none of the person's deals
 * carries a return yet, and shows as a dash rather than 0.0%.
 */

const has = (metrics, key) => !!metrics && Object.prototype.hasOwnProperty.call(metrics, key);

export const formatFunding = (value) => {
  if (value === null || value === undefined) return '—';
  const n = Number(value);
  if (n >= 1_000_000) return `$${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `$${(n / 1_000).toFixed(0)}k`;
  return `$${n}`;
};

export const formatRoce = (value) => (
  value === null || value === undefined ? '—' : `${Number(value).toFixed(1)}%`
);

export const bunkersMoneyTiles = (metrics) => {
  const tiles = [];
  if (has(metrics, 'fuel_funding_required_usd')) {
    tiles.push({ value: formatFunding(metrics.fuel_funding_required_usd), label: 'Funding Required' });
  }
  if (has(metrics, 'fuel_avg_roce_pct')) {
    tiles.push({ value: formatRoce(metrics.fuel_avg_roce_pct), label: 'Avg ROCE' });
  }
  return tiles;
};
